import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { PoBreadcrumb, PoDialogService, PoNotificationService, PoInputComponent } from '@po-ui/ng-components';
import { AtasSociosService } from './atas-socios.service';

@Component({
  selector: 'app-atas-socios',
  templateUrl: './atas-socios.component.html',
  styleUrls: ['./atas-socios.component.css'],
  standalone: false
})
export class AtasSociosComponent implements OnInit, AfterViewInit {

  @ViewChild('valorInput', { static: false }) valorInput!: PoInputComponent;

  idEmpresa: number | null = null;
  valor: number = 0;
  valorDisplay: string = '';
  codJucesp: string = '';
  isLoading: boolean = false;


  readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/home' }, { label: 'Contabilidade' }, { label: 'Atas - Sócios' }]
  };

  constructor(@Inject(AtasSociosService) private readonly atasSociosService: AtasSociosService,
              private readonly poDialogService: PoDialogService,
              private readonly poNotificationService: PoNotificationService) { }

  ngOnInit() {
    this.valorDisplay = 'R$ 0,00';
  }

  ngAfterViewInit() {
    // Adiciona listener de blur diretamente no input nativo
    setTimeout(() => {
      if (this.valorInput?.inputEl?.nativeElement) {
        this.valorInput.inputEl.nativeElement.addEventListener('blur', (event: any) => {
          this.onValorBlur(event);
        });
      }
    }, 0);
  }

  formatCurrency(value: number): string {
    if (!value) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  }

  public onValorBlur(event: any): void {
    // Acessa o input nativo através do componente PO UI
    const inputElement = this.valorInput?.inputEl?.nativeElement || event?.target;
    let value = this.valorDisplay || '';
    
    // Remove todos os caracteres não numéricos (incluindo vírgula, pontos, R$, espaços, etc)
    const onlyNumbers = value.replace(/\D/g, '');
    
    // Se não tiver números, define como 0
    if (!onlyNumbers || onlyNumbers === '') {
      this.valor = 0;
      this.valorDisplay = 'R$ 0,00';
      if (inputElement) {
        inputElement.value = 'R$ 0,00';
      }
      return;
    }
    
    // Converte para número
    const numericValue = parseFloat(onlyNumbers) || 0;
    
    // Divide por 100 para recolocar a vírgula (trata como centavos)
    const decimalValue = numericValue / 100;
    
    // Formata como moeda
    const formatted = this.formatCurrency(decimalValue);
    this.valor = decimalValue;
    this.valorDisplay = formatted;
    
    // Atualiza o input se necessário
    if (inputElement) {
      inputElement.value = formatted;
    }
  }

  requestAtasSocios(form: any) {

    console.log(form);
    console.log(this.codJucesp);
    //return;

    if (!form.valid) {
      // marca campos como tocados
      this.poNotificationService.warning('Preencha corretamente todos os campos obrigatórios.');
      return;
    }

    const valorFormatado = this.formatCurrency(this.valor);
    const codEmpresa = this.idEmpresa != null ? String(this.idEmpresa) : '';
    this.atasSociosService.requestAtasSocios(codEmpresa, valorFormatado,
                                                       this.codJucesp).subscribe((response) => {
      this.poDialogService.alert({
        title: 'Documento - Atas - Sócios',
        message: 'Documento gerado com sucesso. Dentro de instantes você receberá um e-mail com o documento.',
      });

    form.reset();
    this.idEmpresa = null;
    this.valor = 0;
    this.valorDisplay = 'R$ 0,00';
    this.codJucesp = '';

    });
  }
}

